import { Container } from './container';

export const Grid = Object.freeze({
  Container,
});
